import React from 'react'
import '../styles/ProjectStyle.css'
import ProjectsHeader from './ProjectsHeader'

function Projects() {

  const handleClick = () => {
    window.open('http://shashinsite.de/');
  }

  return (
    <div>
      <ProjectsHeader />
      <div id='projectsDiv'>
     <img src='./images/shashinsiteicon.png' alt='shashin-shite' className='projectUnit' onClick={handleClick}/>
    </div>
    </div>
  )
}

export default Projects
